export function computePeriodDates(group, type, offset) {
    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth();

    if (type === 'year') {
        const targetYear = year + offset;
        return { start: `${targetYear}-01-01`, end: `${targetYear}-12-31` };
    }

    if (type === 'month') {
        const d = new Date(year, month + offset, 1);
        const y = d.getFullYear();
        const m = String(d.getMonth() + 1).padStart(2, '0');
        const lastDay = String(new Date(y, d.getMonth() + 1, 0).getDate()).padStart(2, '0');
        return { start: `${y}-${m}-01`, end: `${y}-${m}-${lastDay}` };
    }

    const currentQ = Math.floor(month / 3);
    const absQ = year * 4 + currentQ + offset;
    const targetYear = Math.floor(absQ / 4);
    const targetQ = ((absQ % 4) + 4) % 4;
    const qStartM = targetQ * 3 + 1;
    const qEndM = targetQ * 3 + 3;
    const lastDay = String(new Date(targetYear, qEndM, 0).getDate()).padStart(2, '0');
    return {
        start: `${targetYear}-${String(qStartM).padStart(2, '0')}-01`,
        end: `${targetYear}-${String(qEndM).padStart(2, '0')}-${lastDay}`
    };
}

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export function getPeriodShortLabel(group, type, offset) {
    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth();
    if (type === 'year') return `${year + offset}`;
    if (type === 'month') {
        const d = new Date(year, month + offset, 1);
        return `${String(d.getMonth() + 1).padStart(2, '0')}-${d.getFullYear()}`;
    }
    if (type === 'quarter') {
        const currentQ = Math.floor(month / 3);
        const absQ = year * 4 + currentQ + offset;
        const targetYear = Math.floor(absQ / 4);
        const targetQ = ((absQ % 4) + 4) % 4;
        return `Q${targetQ + 1} ${targetYear}`;
    }
    return '';
}

export function getPeriodLabel(filters) {
    const scopeLabels = { all: 'All Deals', my: 'My Deals' };
    const dimLabels = { created: 'Deals Created', revenue: 'Revenue Recognition' };
    let label = `${scopeLabels[filters.scope] || 'All Deals'} · ${dimLabels[filters.dimension] || 'Deals Created'}`;

    const group = filters.dimension;
    const prefix = group;
    const type = filters[`${prefix}PeriodType`];

    if (type !== 'custom') {
        const dates = computePeriodDates(group, type, filters[`${prefix}PeriodOffset`]);
        if (type === 'year') {
            label += `: ${dates.start?.slice(0, 4)}`;
        } else if (type === 'month') {
            const m = parseInt(dates.start?.slice(5, 7)) - 1;
            const y = dates.start?.slice(0, 4);
            label += `: ${MONTHS[m] || ''} ${y}`;
        } else if (type === 'quarter') {
            const sm = parseInt(dates.start?.slice(5, 7)) - 1;
            const em = parseInt(dates.end?.slice(5, 7)) - 1;
            const y = dates.start?.slice(0, 4);
            const qNum = Math.floor(sm / 3) + 1;
            label += `: Q${qNum} ${y} (${MONTHS[sm]} – ${MONTHS[em]})`;
        }
    } else {
        const fmt = (d) => {
            if (!d) return '…';
            const [y, mNum, day] = d.split('-');
            return `${MONTHS[parseInt(mNum) - 1] || ''} ${parseInt(day)} ${y}`;
        };
        label += `: ${fmt(filters[`${prefix}Start`])} – ${fmt(filters[`${prefix}End`])}`;
    }

    if (filters.dimension === 'created' && type === 'year' && filters.createdPeriodOffset === 0) {
        const scopeText = filters.scope === 'my' ? 'My Deals' : 'All Deals';
        label = `${scopeText} Created: ${new Date().getFullYear()}`;
    }

    return label;
}

export function buildFilterState(filters) {
    const f = { ...filters };
    f.dimension = f.dimension || 'created';
    const prefix = f.dimension === 'revenue' ? 'revenue' : 'created';
    const type = f[`${prefix}PeriodType`] || 'year';
    const offset = f[`${prefix}PeriodOffset`] || 0;

    if (type !== 'custom') {
        const dates = computePeriodDates(f.dimension, type, offset);
        f.startDate = dates.start || null;
        f.endDate = dates.end || null;
        f.dateRangeAll = false;
        f[`${prefix}Start`] = dates.start || '';
        f[`${prefix}End`] = dates.end || '';
    } else {
        f.startDate = f[`${prefix}Start`] || null;
        f.endDate = f[`${prefix}End`] || null;
        f.dateRangeAll = !f.startDate && !f.endDate;
    }
    return f;
}

export function isFilterActive(filters) {
    if (!filters) return false;
    if (filters.scope && filters.scope !== 'all') return true;
    if (filters.ownerIds && filters.ownerIds.length > 0) return true;
    if (filters.accountIds && filters.accountIds.length > 0) return true;
    if (filters.search && filters.search.trim()) return true;
    const dim = filters.dimension || 'created';
    const isDefaultTime =
        dim === 'created' &&
        (filters.createdPeriodType === 'year' || !filters.createdPeriodType) &&
        (filters.createdPeriodOffset === 0 || !filters.createdPeriodOffset) &&
        !filters.createdStart &&
        !filters.createdEnd;
    if (!isDefaultTime) return true;
    return false;
}
